import { z } from 'zod';
import { AvatarSchema } from '../../shared/avatar.schema';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Request Presigned URL Request Schema
 * POST /api/v2/upload-avatar/request-url
 * Requests a presigned URL for direct upload to DigitalOcean Spaces
 */ export const RequestPresignedUrlRequestSchema = z.object({});
/**
 * Request Presigned URL Response Schema
 * Returns presigned POST URL and fields for direct upload
 */ export const RequestPresignedUrlResponseSchema = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    key: z.string(),
    expiresIn: z.number()
});
/**
 * Confirm Upload Request Schema
 * POST /api/v2/upload-avatar/confirm
 * Confirms the upload and triggers processing
 */ export const ConfirmUploadRequestSchema = z.object({
    key: z.string()
});
/**
 * Confirm Upload Response Schema
 * Returns processed avatar URLs
 */ export const ConfirmUploadResponseSchema = z.object({
    avatar: AvatarSchema
});
/**
 * Upload Avatar Error Schema
 */ export const UploadAvatarErrorSchema = BaseErrorSchema;

//# sourceMappingURL=upload-avatar.schema.js.map